
import Vue from 'vue';

interface Computed {
  countdown: string;
  countdownText: string;
  countdownVisible: boolean;
}

interface Data {
  currentTime: number;
}

export default Vue.extend<Data, unknown, Computed, unknown>({
  data() {
    return {
      currentTime: new Date().getTime(),
    };
  },
  computed: {
    countdown() {
      const countdownDate =
        Date.now() > new Date('2024-05-26T07:00:00').getTime() ? new Date('2024-05-26T20:00:00').getTime() : new Date('2024-05-26T07:00:00').getTime();
      const timeRemaining = countdownDate - this.currentTime;
      const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      return `<div class="days">${days}</div><div>:</div><div class="hours">${hours}</div><div>:</div><div class="minutes"> ${minutes}</div><div>:</div><div class="seconds"> ${seconds}</div>`;
    },
    countdownText() {
      if (this.currentTime > new Date('2024-05-26T07:00:00').getTime()) {
        return 'Iki balsavimo pabaigos liko:';
      } else {
        return 'Iki rinkimų 2 turo liko';
      }
    },
    countdownVisible() {
      return this.currentTime < new Date('2024-05-26T20:00:00').getTime();
    },
  },
  created: function () {
    setInterval(() => {
      this.currentTime = new Date().getTime();
    }, 1000);
  },
});
